import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import EditDropdown from '../helperComponent/EditDropdown';

const UpdateClass = () => {
  const [courseData, setCourseData] = useState([
    {
      title: '',
      description: '',
      price: '',
      offerPrice: '',
    },
  ]);
  const [image, setImage] = useState([]);
  const [i, setI] = useState(false);
  const [sub, setSub] = useState([]);

  const handleChange = (e) => {
    setCourseData({ ...courseData, [e.target.name]: e.target.value });
  };

  const { id } = useParams();
  let history = useHistory();
  const btnStyle = {
    background: '#ffcc29',
    color: '#fff',
    border: 'none',
  };
  const uname = JSON.parse(localStorage.getItem('uname'));
  const AuthStr = process.env.REACT_APP_AUTH_STR;
  let fetchUrl = `https://stucharge.bakersbrisk.com/api/getspecificcourse?username=${uname}&id=${id}`;
  let URL = `https://stucharge.bakersbrisk.com/api/courseapi?username=${uname}&id=${id}`;

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios.get(fetchUrl, {
        headers: { Authorization: AuthStr },
      });
      if (result.status === 200) {
        setCourseData(result.data);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var bodyFormData = new FormData();
  const submitHandler = (e) => {
    e.preventDefault();
    // Fire confirmation
    Swal.fire({
      title: 'Are you sure?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        updateClass();
      } else if (result.isDenied) {
        Swal.fire('Course not updated!', '', 'info');
      }
    });
  };

  async function updateClass() {
    if (i) {
      bodyFormData.append('image', image);
    }
    bodyFormData.append('title', courseData.title);
    bodyFormData.append('description', courseData.description);
    bodyFormData.append('price', courseData.price);
    bodyFormData.append('offer_price', courseData.offer_price);
    courseData.subject = sub;
    bodyFormData.append('subject', courseData.subject);

    const requestOptions = {
      method: 'PUT',
      headers: { Authorization: AuthStr },
      body: bodyFormData,
    };
    fetch(URL, requestOptions)
      .then(async (response) => {
        const data = await response.json();
        // check for error response
        if (!response.ok) {
          const error = (data && data.message) || response.status;
          return Promise.reject(error);
        }
        Swal.fire('Course updated successfully!', '', 'success').then(
          (result) => {
            if (result.isConfirmed || !result.isConfirmed) {
              history.push('/home');
              history.push('/courses');
            }
          }
        );
      })
      .catch((error) => {
        Swal.fire('Error updating course', '', 'error');
      });
  }

  // Image upload
  const handleImageUpload = (e) => {
    e.preventDefault();
    setI(true);
    const file = e.target.files;
    setImage(file[0]);
  };

  // handle offer price
  const handleOfferPrice = (e) => {
    const op = e.target.value;
    if (op < 0) {
      setCourseData({ ...courseData, [e.target.name]: 0 });
    } else if (parseInt(op, 10) > parseInt(courseData.price, 10)) {
      setCourseData({ ...courseData, [e.target.name]: courseData.price });
    } else {
      setCourseData({ ...courseData, [e.target.name]: e.target.value });
    }
  };

  return (
    <div className='main_container'>
      <div className='alert-heading'>
        <h1>Update Course Details</h1>
      </div>
      <form onSubmit={(e) => submitHandler(e)} className='class-form'>
        <div className='form-control'>
          <label htmlFor='title'>Title</label>
          <input
            type='text'
            value={courseData.title || ''}
            required
            name='title'
            onChange={(e) => handleChange(e)}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='subject'>Subject</label>
          <EditDropdown
            setSub={setSub}
            value={courseData.subject ? courseData.subject.name : 'Select'}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='url'>Description</label>
          <textarea
            type='text'
            className='update-detail'
            value={courseData.description || ''}
            required
            name='description'
            onChange={(e) => handleChange(e)}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='price'>Price</label>
          <input
            type='number'
            value={courseData.price || ''}
            required
            name='price'
            onChange={(e) => handleChange(e)}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='offerPrice'>Offer Price</label>
          <input
            type='number'
            value={courseData.offer_price || ''}
            required
            name='offer_price'
            onChange={(e) => handleOfferPrice(e)}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='image'>Update Cover Image</label>
          <input
            type='file'
            name='image'
            accept='image/x-png,image/gif,image/jpeg'
            onChange={(e) => handleImageUpload(e)}
          />
        </div>
        <button type='submit' className='btn' style={btnStyle}>
          Update Course
        </button>
      </form>
    </div>
  );
};

export default UpdateClass;
